import styled from 'styled-components';

export const Image = styled.img`
    width: 300px;
    height: 250px;
    border-radius: 6px;
    @media screen and (max-width: 690px) {
        width: 100%;
        height: auto;
    }
`;
